import { KngButtonState } from './definitions';

export class KngButtonFactory 
{
	public static build(): KngButtonState 
	{
		return {
			size: 'small',
			style: 'primary',
			disabled: false,
			label: 'Button',
			icon: {
				altText: '',
				iconPath: ''
			},
			position: 'left'
		};
	}
}
